/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const TITLES = {
  ADD: "ADD",
  CANCEL: "Cancel",
  ADD_REALM: "Add Realm",
  EDIT_REALM: "Edit Realm",
  CUSTOMER_ENVIRONMENT_TYPE: "Customer Environment Type",
  DISPLAY_NAME: "Display Name",
  EMAIL: "Email",
  GEO: "Geo",
  INSTANCE: "Instance",
  REALM_NAME: "Realm Name",
};
export const REALM_NAME_REGEX = /^[a-zA-Z0-9_-]+$/;
export const MESSAGES = {
  REALM_NAME_INFO: "Realm Name is required, It can only contain alphanumeric (a-z, 0-9) and (-,_) characters.",
  GEO_REQUIRED: "Geo is required",
  EMAIL_REQUIRED: "Email is required",
  INSTANCE_REQUIRED: "Instance is required",
  ADD_REALM_SUCCESS: "Realm added successfully",
  REALM_NAME_REQUIRED: "Realm Name is required",
  REALM_NAME_REGEX_ERROR: "Realm Name can only contain alphanumeric (a-z, 0-9) and (-,_) characters.",
  EDIT_REALM_SUCCESS: "Realm edited successfully",
  REALM_INSTANCE_INFO: "The instance of the realm",
  REALM_GEO_INFO: "The geographical location of the realm",
  REALM_DISPLAY_NAME_INFO: "A More descriptive name for the realm",
  CUSTOMER_ENVIRONMENT_TYPE_REQUIRED: "Customer environment type is required",
  REALM_CUSTOMER_ENVIRONMENT_TYPE_INFO: "Type of environment that will be configured with LIAM, such as development (dev), test, or production (prod).",
  REALM_INFO: `Realm Key is auto generated, based on account name and env type, Your realm key will be:`,
  REALM_EMAIL_INFO: `User name of the user requiring administrative access. 

  If this is a customer user, enter the identity provider preferred username of the user.
  
  If this is a Blue Yonder Customer Support user, enter the user's jdadelivers username, such as 1011010@jda.delivers.com.
  
  If this is an internal Blue Yonder user, enter the associate's jda.com email address.`,
};
